<template>
  <button
    :title="toolTip"
    :aria-label="label"
    :disabled="disabled"
    class="square-icon-button justify-center items-center"
    :class="{
      ['icon-disabled']: disabled,
    }"
  >
    <span class="material-symbols-outlined" aria-hidden="true">
      {{ iconName }}
    </span>
  </button>
</template>
<script setup lang="ts">
import { computed } from "vue";

import { CommandProps } from "@/commands/props";

const props = defineProps<CommandProps>();

const iconName = computed(() =>
  typeof props.icon === "string" ? props.icon : props.icon.name
);
</script>
<style scoped lang="scss">
.icon-disabled {
  color: var(--DM__color-grisFonce);
  opacity: 0.7;
  background-color: var(--DM__color-fill);
  cursor: not-allowed;
}
</style>
